import { Autocomplete, TextField } from "@mui/material";
// import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FPFormSelectPropsType } from "./interface";

const useStyles = makeStyles({
    searchable: {
        marginTop: "10px",
    },
});

const FPFormSelect = ({
    formList,
    optionsSelectedHandler,
    value,
}: FPFormSelectPropsType) => {
    const classes = useStyles();

    return (
        <Autocomplete
            className={classes.searchable}
            id="fp-form-select"
            options={formList}
            value={value}
            multiple={true}
            disableCloseOnSelect
            onChange={(e: any, selectedOptions: any) => {
                optionsSelectedHandler(selectedOptions);
            }}
            getOptionLabel={(option: any) => option.name}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={"FP Form List"}
                />
            )}
        />
    );
};

export default FPFormSelect;
